export const shouldApplyRecoverySnapshot = (
  key: string,
  versionsAtRequestStart: ReadonlyMap<string, number>,
  currentVersions: ReadonlyMap<string, number>
) =>
  (currentVersions.get(key) || 0) ===
  (versionsAtRequestStart.get(key) || 0)

export const getProgressUpdateTime = ({
  serverUpdatedAt,
  observedAt,
  initiatedAt,
}: {
  serverUpdatedAt?: string
  observedAt?: string
  initiatedAt?: string
}) =>
  serverUpdatedAt || observedAt || initiatedAt || new Date().toISOString()
